import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { REQUETE_DE_FOND } from '../../../core/interceptors/error.interceptor';

/** Un libellé bilingue tel que le serveur le sert (`BilingualText`). */
export interface TexteBilingue {
  readonly ar?: string | null;
  readonly fr?: string | null;
}

export interface ResultatApi {
  readonly id: string;
  readonly titre: TexteBilingue;
  readonly reference?: string | null;
  readonly contexte?: TexteBilingue | null;
  readonly statut?: string | null;
  /** Paramètres de route autres que l'id (`year`, `period`…), pour les écrans qui en exigent. */
  readonly parametres?: Readonly<Record<string, string>> | null;
}

export interface CategorieApi {
  readonly code: string;
  readonly resultats: readonly ResultatApi[];
}

export interface ReponseRecherche {
  readonly espace: string;
  readonly requete: string;
  readonly categories: readonly CategorieApi[];
}

/**
 * `GET /api/recherche?espace=…&q=…` — les objets métier visibles de l'utilisateur DANS l'espace courant.
 * Le cloisonnement est entièrement serveur (rôle de l'espace, puis portée de chaque module) : la SPA
 * affiche ce qu'on lui sert, elle ne filtre aucun droit.
 */
@Injectable({ providedIn: 'root' })
export class RechercheApi {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiBaseUrl}/recherche`;

  /**
   * Requête de FOND : elle part à la frappe, sans geste de navigation de l'agent — un 401 s'y répare en
   * silence au lieu de le renvoyer à la page de connexion au milieu d'un mot.
   */
  chercher(espace: string, q: string, limite = 5): Observable<ReponseRecherche> {
    return this.http.get<ReponseRecherche>(this.url, {
      params: { espace, q, limite },
      context: new HttpContext().set(REQUETE_DE_FOND, true),
    });
  }
}
